// React
import React from "react";

// ANTD Notification
import { notification as Notification } from "antd";

// Icons
import {
  CheckCircleFilled,
  // InfoCircleFilled,
  // WarningFilled,
} from "@ant-design/icons";

// Styles
import "./notifications.scss";
import cx from "classnames";

export const customNotification = (
  type,
  message,
  description = "",
  isRTL = false,
  options = {}
) => {
  const { key, duration, icon } = options;
  const notificationProps = {
    message: message,
    description: (
      <div className="fs-medium fw-500 notification-text">{description}</div>
    ),
    icon: type === "success" && (
      <CheckCircleFilled className="success-notification-icon" />
    ),
    // use this icon if you have better fill color
    // icon:
    //   type === "success" ? (
    //     <CheckCircleFilled className="success-notification-icon" />
    //   ) : type === "info" ? (
    //     <InfoCircleFilled className="info-notification-icon" />
    //   ) : (
    //     <WarningFilled className="warning-notification-icon" />
    //   ),
    style: { borderRadius: "10px" },
    className: cx("edit-goal-success-notification", {
      "update-notification-rtl": isRTL,
    }),
    placement: isRTL ? "topLeft" : "topRight",
  };

  if (key) {
    notificationProps.key = key;
  }
  if (duration !== undefined) {
    notificationProps.duration = duration;
  }
  if (icon) {
    notificationProps.icon = icon;
  }

  if (typeof Notification[type] === "function") {
    Notification[type](notificationProps);
  } else {
    Notification.open(notificationProps);
  }
  // return Notification.destroy();
};
